export default "__VITE_ASSET__CzeG2lRX__"